<template>
  <div>
    <rest-form-item
      prop="params.mapping"
      style="display: none"
    ></rest-form-item>
    <data-mapper
      v-if="model.params.hasOwnProperty('mapping') && columns.length > 0"
      :columns="columns"
      :attributes-prop="attributes"
      :fixed-mappings="model.fixedMappings"
      :filterable-attributes="filterableAttributes"
    />
  </div>
</template>

<script>
import DataMapper from '@/common/components/DataMapper'
import RestFormItem from '@/common/components/rest/RestFormItem'
export default {
  name: 'MappingStep',
  props: {
    model: {
      type: Object
    }
  },

  components: {
    RestFormItem,
    DataMapper
  },
  mounted() {
    this.columns = this.model.params.mapping
    this.toggleStep()
    if (this.stepIsCompleted === false) {
      this.$message({
        message: this.$t('Imports_Message_IdNotAssigned'),
        type: 'error'
      })
    }
  },
  data() {
    return {
      attributes: [],
      columns: [],
      filterableAttributes: [
        'user_id',
        'customer_id',
        'email',
        'mobile_number',
        'whatsapp_number',
        'language',
        'timezone',
        'email_addressable',
        'email_subscription',
        'sms_addressable',
        'sms_subscription'
      ],
      isLoading: false
    }
  },
  computed: {
    stepIsCompleted() {
      return this.model.params.mapping.some(
        e =>
          e.attribute &&
          e.attribute !== '' &&
          e.attribute !== null &&
          e.attribute === 'user_id'
      )
    }
  },
  methods: {
    toggleStep() {
      this.$emit('can-continue', { value: this.stepIsCompleted })
      this.$emit('change-next', { nextBtnValue: this.stepIsCompleted })
    }
  },
  watch: {
    stepIsCompleted() {
      this.toggleStep()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/shopify/MappingStep.vue